const videoActionSlides = document.querySelectorAll('#homepage-content-header .swiper-slide');

videoActionSlides.forEach(function(videoActionSlide) {
    const headerFigure = videoActionSlide.querySelector('.header-visual-content');
    const videoActionButton = videoActionSlide.querySelector('.video-action');
    const returnButton = videoActionSlide.querySelector('.return-button');
    const videoURL = headerFigure.getAttribute('data-video-url');
    const mobileVideoURL = headerFigure.getAttribute('data-mobilevideo-url');

    try {
        const videoDomain = (new URL(videoURL));
        const videoDomainHostname = videoDomain.hostname.replace('www.','');

        let responseJSON = '';

        let urlWithDimensions = window.innerWidth < 768 ? `${mobileVideoURL}&width=700&height=350` : `${videoURL}&width=1920&height=1080`;
        let requestURL = 'https://vimeo.com/api/oembed.json?url=' + urlWithDimensions;

        if(videoDomainHostname == 'vimeo.com' && videoActionButton != null){
            videoActionButton.addEventListener("click", function() {
                if(videoActionSlide.classList.contains('generated')){
                    videoActionSlide.classList.add('open');
                }else{
                    const loadVimeoResponse = async(requestURL) => {
                        try {
                            const res = await fetch(requestURL);
                            responseJSON = await res.json();
                            let vimeoHTML = responseJSON.html;
                            headerFigure.insertAdjacentHTML('beforeend' , vimeoHTML);
                    
                        } catch (err) {
                            console.error(err);
                        }
                    };
                    loadVimeoResponse(requestURL);
                    //play vimeo video
                    videoActionSlide.classList.add('generated' , 'open' , 'iframe');
                }
            });
            returnButton.addEventListener("click", function() {
                if(videoActionSlide.classList.contains('open')){
                    videoActionSlide.classList.remove('open');
                    //pause vimeo video
                } 
            });
        }else{
            videoActionButton.addEventListener("click", function() {
                if(videoActionSlide.classList.contains('generated')){
                    videoActionSlide.classList.add('open');
                    const videoElement = headerFigure.querySelector('.header-video');
                    videoElement.play();
                } else{
                    const videoElement = document.createElement("video");
                    videoElement.classList.add('header-video');
                    videoElement.setAttribute("autoplay", "autoplay");
                    videoElement.setAttribute("loop", "loop");
                    videoElement.setAttribute("muted", "muted");
                    videoElement.setAttribute("playsinline", "playsinline");
                    videoElement.setAttribute("preload", "preload");
                    videoElement.setAttribute("controls", "controls");
                    videoElement.setAttribute("src", videoURL);
                    headerFigure.appendChild(videoElement);
        
                    videoActionSlide.classList.add('generated' , 'open');
                }
            });

            returnButton.addEventListener("click", function() {
                if(videoActionSlide.classList.contains('open')){
                    const videoElement = headerFigure.querySelector('.header-video');
                    videoElement.pause();
                    videoActionSlide.classList.remove('open');
                } 
            });
        }
    }
    catch(err) {
        console.log('Do Nothing, LeBron...');
    }
});